(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => {
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
  };

  // src/js/components/inputs.js
  var _Inputs = class {
    static init() {
      const inputs = window.Store.app.theContainer.querySelectorAll(_Inputs.param.handled_inputs.map((i) => i = `${_Inputs.param.selector} ${i}`).join(", "));
      if (!inputs.length) {
        return false;
      }
      inputs.forEach((input) => {
        if (input.tagName == "INPUT" || input.tagName == "TEXTAREA") {
          input.addEventListener("focusin", (e) => _Inputs.checkInput(e.target, true));
          input.addEventListener("focusout blur", (e) => _Inputs.checkInput(e.target));
          _Inputs.checkInput(input, false);
        } else if (input.tagName == "SELECT") {
          input.addEventListener("change", (e) => _Inputs.checkInput(e.target));
          _Inputs.checkInput(input, false);
        }
      });
      _Inputs.addGlobalEventListener();
      return true;
    }
    static checkInput(input, force_focus = false) {
      const wrapper = input.closest(_Inputs.param.selector);
      let shouldFocus;
      if (!wrapper) {
        return false;
      }
      if (input.tagName == "INPUT" || input.tagName == "TEXTAREA") {
        shouldFocus = force_focus || input.value.length > 0;
      } else if (input.tagName == "SELECT") {
        shouldFocus = force_focus || !input.options[input.selectedIndex].disabled;
      }
      wrapper.classList.toggle(_Inputs.param.modifiers.label_up, shouldFocus);
      if (wrapper.classList.contains(_Inputs.param.modifiers.input_error)) {
        setTimeout(() => {
          wrapper.classList.remove(_Inputs.param.modifiers.input_error);
        }, _Inputs.param.error_delay);
      }
    }
    static initCheckAutofill() {
      _Inputs.addGlobalEventListener("blur", function(target) {
        window.setTimeout(function() {
          _Inputs.checkInput(target);
        }, 20);
      });
    }
    static addGlobalEventListener(eventName, listener) {
      if (!document.body.addEventListener) {
        document.body.attachEvent(eventName, onEvent);
      } else {
        document.body.addEventListener(eventName, onEvent, true);
      }
      function onEvent(event) {
        const target = event.target;
        listener(target);
      }
    }
  };
  var Inputs = _Inputs;
  __publicField(Inputs, "param", {
    selector: ".js-label",
    handled_inputs: ["input", "select", "textarea"],
    error_delay: 5e3,
    modifiers: {
      label_up: "is-up",
      input_error: "has-error"
    }
  });
  function render() {
    Inputs.initCheckAutofill();
    Inputs.init();
  }
  window.Store.components.inputs.render = render;
})();
